import { Alert } from "models";
import { atom } from "recoil";

export const alertsAtom = atom<Alert[]>({
  key: "alertsState",
  default: [],
});
